module.exports = __webpack_public_path__ + "img/fig08.2c215fbf.jpg";